import { SearchBy, SearchField } from '../../../../types/commonTypes';
import { Menu, MenuItem } from '../../../../components/Menu';

interface Props {
  anchorEl: Element | null;
  changeSearchBy: (searchBy: SearchBy) => void;
  fields: SearchField[];
  onClose(): void;
}

export const SearchByMenu = (props: Props) => {
  const { anchorEl, changeSearchBy, fields, onClose } = props;

  return (
    <Menu
      anchorEl={anchorEl}
      onClose={onClose}
      placement="bottom-start"
      offsetY={2}
    >
      {fields.map((field) => {
        return (
          <MenuItem
            key={field.value}
            onClick={() => changeSearchBy(field.value)}
          >
            {field.label}
          </MenuItem>
        );
      })}
    </Menu>
  );
};
